import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import { useGetTranslations } from './useGetTranslations';
import { VSF_COUNTRY_COOKIE } from '~/constants/vsf';
import { countries } from '~/utils/localization';
var useShippingCountry = function useShippingCountry() {
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var _useNuxt2App = useNuxt2App(),
    ctConfig = _useNuxt2App.$vsf.$ct.config;
  var countryCookie = useCookie(VSF_COUNTRY_COOKIE, {
    watch: process.client ? 'shallow' : false,
    readonly: process.server,
    maxAge: 6 * 30 * 24 * 60 * 60,
    // 6 months (approximately)
    default: function _default() {
      if (process.server) {
        var _serverEvent$context;
        var serverEvent = useRequestEvent();
        return (_serverEvent$context = serverEvent.context) === null || _serverEvent$context === void 0 ? void 0 : _serverEvent$context.country;
      }
      return ctConfig.country;
    }
  });
  function setCountryCode(country) {
    if (country === countryCookie.value) {
      return;
    }
    countryCookie.value = country;
  }
  var availableCountries = computed(function () {
    return countries.filter(function (c) {
      return !c.disabled;
    }).sort(function (a, b) {
      return translate(a.label).localeCompare(translate(b.label));
    });
  });
  var setShippingCountry = function setShippingCountry(countryCode) {
    var needReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!countryCode || countryCode === countryCookie.value) {
      return;
    }
    var newCountryCode = countryCode.toUpperCase();
    ctConfig.country = newCountryCode;
    setCountryCode(newCountryCode);
    if (needReload && process.client) {
      location.reload();
    }
  };
  var country = computed(function () {
    var _countryCookie$value;
    return (_countryCookie$value = countryCookie.value) !== null && _countryCookie$value !== void 0 ? _countryCookie$value : ctConfig.country;
  });
  return {
    country: country,
    setCountryCode: setCountryCode,
    availableCountries: availableCountries,
    setShippingCountry: setShippingCountry
  };
};
export default useShippingCountry;